import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiUrlZero: process.env.NODE_ENV === 'development' ? 'http://192.168.1.119:11088' : 'http://116.62.51.212:11088'
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
